import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ListComponent } from 'src/app/common/component/list.component';
import { MatSort } from '@angular/material/sort';

@Component({
	selector: 'app-products-list',
	templateUrl: './products-list.component.html',
	styleUrls: ['./products-list.component.css'],
})
export class ProductsListComponent extends ListComponent implements AfterViewInit {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	protected itemsBeforeDataLoad = 4;
	protected apiUrl = 'product';
	protected apiType = 'bag';
	protected filterValue = '';

	displayedColumns: string[] = ['position', 'id', 'code', 'name', 'type', 'tags', 'locationsName', 'status', 'edit'];

	showTable = true;
	matData = new MatTableDataSource<any>();

	statusSet: Array<any> = [
		{ value: 'D', name: 'Szkic' },
		{ value: 'P', name: 'Opublikowany' },
		{ value: 'A', name: 'Zarchiwizowany' },
	];

	tableRows = [
		{ id: 'id', name: 'ID' },
		{ id: 'code', name: 'Kod' },
		{ id: 'name', name: 'Nazwa' },
		{ id: 'type', name: 'Typ' },
		{ id: 'tags', name: 'Tagi' },
		{ id: 'locationsName', name: 'Lokalizacja' },
		{ id: 'status', name: 'Status' },
	];

	filters;

	parameters = {
		type: null,
		tags: null,
		status: null,
		location: null,
	};

	ngAfterViewInit() {
		this.matData.sort = this.sort;
		this.matData.paginator = this.paginator;
	}

	protected loadBefore(): void {
		this.bag.get('/product/kind/?limit=9999', (result, error) => {
			this.parameters.type = result.results;
			this.loadData();
		});

		this.bag.get('/tag/?limit=9999', (result, error) => {
			this.parameters.tags = result.results;
			this.loadData();
		});

		this.bag.get('/location/?limit=9999', (result, error) => {
			this.parameters.location = result.results;
			this.loadData();
		});
	}
	protected convertData(result) {
		this.matData.data = result.results.map((item) => {
			item.type = item.productKind?.name;

			item.locationsName = item.location.map((location: { name: any }) => {
				return location.name;
			});

			item.tags = item.tags.map((tag: { name: any }) => {
				return tag.name;
			});

			const matchStatus = this.statusSet.find((findObj) => findObj.value === item.status);
			item.status = matchStatus ? matchStatus.name : '';

			return item;
		});

		this.showTable = this.matData.data.length == 0 ? false : true;
	}

	refreshFilter() {
		if (this.filterValue.length < 3 && this.filterValue.length > 0) {
			return;
		}
		this.matData.filter = this.filterValue.trim().toLowerCase();
	}
}
